module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-05.4273bec4.png";